function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Abs from '../../../assets/illustrations/Afvalbrengstation.svg';
import Gft from '../../../assets/illustrations/Gft.svg';
import Papier from '../../../assets/illustrations/Papier.svg';
import Glas from '../../../assets/illustrations/Glas.svg';
import Restafval from '../../../assets/illustrations/Restafval.svg';
import Plastic from '../../../assets/illustrations/Plastic.svg';
import Textiel from '../../../assets/illustrations/Textiel.svg';
import Reinigen from '../../../assets/illustrations/Reiniging-bakken.svg';
import Kringloop from '../../../assets/illustrations/Kringloop.svg';
import { WASTE_STREAM_ABS, WASTE_STREAM_CLEAN, WASTE_STREAM_GFT, WASTE_STREAM_GLAS, WASTE_STREAM_PAPER, WASTE_STREAM_PMD, WASTE_STREAM_REST, WASTE_STREAM_TEXTILE } from '../../config/constants';
const WasteIcon = props => {
  const {
    t
  } = useTranslation();
  const {
    ...rest
  } = props;
  let uid = null;
  if ('streamUid' in props) {
    const {
      streamUid
    } = props;
    // @ts-ignore
    delete rest.streamUid;
    uid = streamUid;
  } else {
    const {
      streamId
    } = props;
    // @ts-ignore
    delete rest.streamId;
    switch (streamId) {
      case WASTE_STREAM_ABS:
        uid = 'ABS';
        break;
      case WASTE_STREAM_PAPER:
        uid = 'PAPIER';
        break;
      case WASTE_STREAM_GFT:
        uid = 'GFT';
        break;
      case WASTE_STREAM_PMD:
        uid = 'PBD';
        break;
      case WASTE_STREAM_GLAS:
        uid = 'GLAS';
        break;
      case WASTE_STREAM_REST:
        uid = 'REST';
        break;
      case WASTE_STREAM_TEXTILE:
        uid = 'TEXTIEL';
        break;
      case WASTE_STREAM_CLEAN:
        uid = 'REINIGEN';
        break;
      default:
    }
  }
  switch (uid) {
    case 'ABS':
      return /*#__PURE__*/React.createElement("img", _extends({
        src: Abs,
        alt: t('waste_icon.alt_texts.WASTE_STREAM_ABS')
      }, rest));
    case 'PAPIER':
      return /*#__PURE__*/React.createElement("img", _extends({
        src: Papier,
        alt: t('waste_icon.alt_texts.WASTE_STREAM_PAPER')
      }, rest));
    case 'GFT':
      return /*#__PURE__*/React.createElement("img", _extends({
        src: Gft,
        alt: t('waste_icon.alt_texts.WASTE_STREAM_GFT')
      }, rest));
    case 'PBD':
      return /*#__PURE__*/React.createElement("img", _extends({
        src: Plastic,
        alt: t('waste_icon.alt_texts.WASTE_STREAM_PMD')
      }, rest));
    case 'GLAS':
      return /*#__PURE__*/React.createElement("img", _extends({
        src: Glas,
        alt: t('waste_icon.alt_texts.WASTE_STREAM_GLAS')
      }, rest));
    case 'REST':
      return /*#__PURE__*/React.createElement("img", _extends({
        src: Restafval,
        alt: t('waste_icon.alt_texts.WASTE_STREAM_REST')
      }, rest));
    case 'TEXTIEL':
      return /*#__PURE__*/React.createElement("img", _extends({
        src: Textiel,
        alt: t('waste_icon.alt_texts.WASTE_STREAM_TEXTILE')
      }, rest));
    case 'REINIGEN':
      return /*#__PURE__*/React.createElement("img", _extends({
        src: Reinigen,
        alt: t('waste_icon.alt_texts.WASTE_STREAM_CLEAN')
      }, rest));
    case 'KRINGLOOP':
      return /*#__PURE__*/React.createElement("img", _extends({
        src: Kringloop,
        alt: t('waste_icon.alt_texts.WASTE_STREAM_KRINGLOOP')
      }, rest));
    default:
      return /*#__PURE__*/React.createElement("div", null, t('waste_icon.not_found', {
        streamId: uid
      }));
  }
};
export default WasteIcon;